(() => {
    document.addEventListener("DOMContentLoaded", function() {
        document.querySelector(`[name="id"]`).addEventListener("change", e => {
        setTimeout(() => {
            const productForm = document.querySelector(".product__info-container");
            BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
        }, 200)
    })
    });
})()